var React = require('react');

function IcCheck (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"ic-check","d":"M5.366 12.983a1.18 1.18 0 0 1-.76-.49L2.214 9.03a1.2 1.2 0 0 1 .289-1.658 1.167 1.167 0 0 1 1.638.293L5.716 9.94l6.26-6.577a1.167 1.167 0 0 1 1.663-.03c.469.455.482 1.209.033 1.683l-7.254 7.618a1.167 1.167 0 0 1-1.052.348"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M0 0h16v16H0z","key":0}),React.createElement("use",{"fill":"#3277EA","xlinkHref":"#ic-check","key":1})])]);
}

IcCheck.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = IcCheck;

IcCheck.default = IcCheck;
